const replaceHTMLAttributes = (
  htmlString,
  attributeName,
  replacementString,
) => {
  // Create a regular expression pattern to match the attribute value
  const regex = new RegExp(`${attributeName}=["'](.*?)["']`, "g");

  // Use the `replace` method to replace the attribute values
  const modifiedHTML = htmlString.replace(
    regex,
    `${attributeName}="${replacementString}"`,
  );

  return modifiedHTML;
};

var removeHTMLAttributes = (htmlString, attributeName) => {
  // Create a regular expression pattern to match the attribute value
  const regex = new RegExp(`${attributeName}=["'](.*?)["']`, "g");

  // Use the `replace` method to replace the attribute values
  const modifiedHTML = htmlString.replace(regex, "");

  return modifiedHTML;
};

var triggerEvent = (element, name, data = {}) => {
  window.events = window.events || {};
  if (!window.events[name]) {
    window.events[name] = debounce((element, name, data) => {
      element.dispatchEvent(
        new CustomEvent(name, {
          bubbles: true,
          detail: data,
        }),
      );
    }, 300);
  }
  window.events[name](element, name, data);
};

var delegate = (parent, eventName, childSelector, callback) => {
  if (typeof childSelector === "function") {
    callback = childSelector;
    childSelector = null;
  }
  const selector = childSelector
    ? childSelector
    : "." + [...parent.classList].join(".").replaceAll(":", "\\:");
  parent.addEventListener(eventName, (event) => {
    const target = event.target.closest(selector);
    if (target) {
      callback(event, target);
    }
  });
};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

var trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function (e) {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document
    .querySelectorAll("model-viewer")
    .forEach((model) => model.modelViewerUI?.pause());
}

function pauseThisMedia(media) {
  if (media.tagName === "VIDEO") {
    media.pause();
  } else if (media.tagName === "IFRAME") {
    if (media.classList.contains("js-youtube")) {
      media.contentWindow.postMessage(
        JSON.stringify({ event: "command", func: "stopVideo", args: [] }),
        "*",
      );
    } else if (media.classList.contains("js-vimeo")) {
      media.contentWindow.postMessage('{"method":"pause"}', "*");
    }
  } else if (media.tagName === "MODEL-VIEWER") {
    media.modelViewerUI?.pause();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

// Scroll lock manager with reference counting
var scrollLockManager = {
  lockedBy: new Set(),
  scrollY: 0,
  /** @type {'fixed' | 'overflow' | null} */
  lockMode: null,

  /**
   * Read current page scroll from all common scrolling roots.
   * @returns {number}
   */
  getCurrentScrollY() {
    return window.scrollY
      || window.pageYOffset
      || document.documentElement.scrollTop
      || document.body.scrollTop
      || 0;
  },

  /**
   * Restore scroll position for both body-scrolling and window-scrolling pages.
   * @param {number} top
   */
  restoreScrollY(top) {
    const html = document.documentElement;
    const body = document.body;
    const prevHtmlBehavior = html.style.scrollBehavior;
    const prevBodyBehavior = body.style.scrollBehavior;

    // Override theme-level `scroll-smooth` so lock/unlock never animates.
    html.style.scrollBehavior = "auto";
    body.style.scrollBehavior = "auto";

    document.documentElement.scrollTop = top;
    document.body.scrollTop = top;
    window.scrollTo(0, top);

    requestAnimationFrame(() => {
      html.style.scrollBehavior = prevHtmlBehavior;
      body.style.scrollBehavior = prevBodyBehavior;
    });
  },

  /**
   * @param {Element} element
   * @param {{ mode?: 'fixed' | 'overflow' }} [options]
   */
  lock(element, options = {}) {
    if (this.lockedBy.size === 0) {
      this.scrollY = this.getCurrentScrollY();
      this.lockMode = options.mode === "overflow" ? "overflow" : "fixed";

      if (this.lockMode === "overflow") {
        document.documentElement.style.overflow = "hidden";
        document.body.style.overflow = "hidden";
        this.restoreScrollY(this.scrollY);
      } else {
        document.body.style.position = "fixed";
        document.body.style.top = `-${this.scrollY}px`;
        document.body.style.width = "100%";
      }
    }

    this.lockedBy.add(element);
    element.dataset.scrollY = String(this.scrollY);
  },

  unlock(element) {
    this.lockedBy.delete(element);

    if (this.lockedBy.size === 0) {
      if (this.lockMode === "overflow") {
        document.documentElement.style.overflow = "";
        document.body.style.overflow = "";
        const currentScroll = this.getCurrentScrollY();
        if (Math.abs(currentScroll - this.scrollY) > 1) {
          this.restoreScrollY(this.scrollY);
        }
      } else {
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";
        this.restoreScrollY(this.scrollY);
      }
      this.lockMode = null;
    }
  },

  isLocked() {
    return this.lockedBy.size > 0;
  },

  clear() {
    this.lockedBy.clear();
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    this.lockMode = null;
  }
};

// Maintain backward compatibility
/**
 * @param {Element} element
 * @param {{ mode?: 'fixed' | 'overflow' }} [options]
 */
function lockScrollForThis(element, options = {}) {
  scrollLockManager.lock(element, options);
}

function unlockScrollForThis(element) {
  scrollLockManager.unlock(element);
}

function preventDefault(e) {
  e.preventDefault();
}

function handleImageError(imgElement) {
  imgElement.classList.add("hidden");
  const fallback = imgElement.parentElement.querySelector(".fallback");
  fallback.classList.remove("hidden");
}

function getPathWithoutQuery(url) {
  return new URL(url, window.location.origin).pathname;
}
function replaceNodeWithNodeList(nodeToReplace, nodeList) {
  if (!(nodeList instanceof NodeList) && !Array.isArray(nodeList)) {
    throw new Error("Second argument must be a NodeList or an array of nodes");
  }

  const parent = nodeToReplace.parentNode;
  if (!parent) {
    throw new Error("Cannot replace a node that is not in the DOM");
  }

  const fragment = document.createDocumentFragment();

  // If it's an array, we need to iterate differently
  if (Array.isArray(nodeList)) {
    nodeList.forEach((node) => fragment.appendChild(node));
  } else {
    // NodeList is array-like but not an array, so we use this method
    fragment.append(...nodeList);
  }

  parent.replaceChild(fragment, nodeToReplace);
}

function toggleButtonState(button, state) {
  switch (state) {
    case "loading":
      if (button.dataset.state == "loading") return;
      button.setAttribute("aria-disabled", true);
      button.dataset.state = "loading";
      break;

    case "error":
      button.dataset.state = "error";
      button.removeAttribute("aria-disabled");
      navigator.vibrate(100);
      setTimeout(() => button.removeAttribute("data-state"), 3000);
      break;

    case "success":
      button.dataset.state = "success";
      button.removeAttribute("aria-disabled");
      navigator.vibrate(100);
      setTimeout(() => button.removeAttribute("data-state"), 3000);
      break;
  }
}

function updateLabels() {
  const labels = document.querySelectorAll("drawer accordion-content label");
  labels.forEach((label) => {
    const attr = label.getAttribute("for");
    const input = label.querySelector("input");
    if (input) input.setAttribute("id", attr);
    label.setAttribute("for", attr);
    label.control = input;
  });
}

function getVisibleHeight(element) {
  // Get the element's bounding rectangle
  const rect = element.getBoundingClientRect();

  // Get viewport height
  const viewportHeight =
    window.innerHeight || document.documentElement.clientHeight;

  // Calculate top and bottom edges relative to viewport
  const elementTop = rect.top;
  const elementBottom = rect.bottom;

  // Element is completely above or below viewport
  if (elementTop >= viewportHeight || elementBottom <= 0) {
    return 0;
  }

  // Element is partially visible
  if (elementTop < 0) {
    // Element is clipped at top
    return Math.min(elementBottom, viewportHeight);
  }

  if (elementBottom > viewportHeight) {
    // Element is clipped at bottom
    return viewportHeight - elementTop;
  }

  // Element is fully visible
  return rect.height;
}

// fix childMenu positions
var fixChildMenuPositions = () => {
  const childMenus = document.querySelectorAll("._headerChildMenu");
  const isRTL = document.body.style.direction === "rtl";
  const windowWidth = window.innerWidth;

  childMenus.forEach((childMenu) => {
    let isOffScreen = false;
    const childMenuRect = childMenu.getBoundingClientRect();

    // Check if the child menu itself is off-screen
    if (isRTL) {
      isOffScreen = childMenuRect.left < 0;
    } else {
      isOffScreen = childMenuRect.right > windowWidth;
    }

    // If child menu is not off-screen, check its grandchild menus
    if (!isOffScreen) {
      const grandChildMenus = childMenu.querySelectorAll(
        "._headerGrandChildMenu",
      );
      grandChildMenus.forEach((grandChildMenu) => {
        // Temporarily make the grandchild menu visible for accurate measurements
        const originalDisplay = grandChildMenu.style.display;
        grandChildMenu.style.display = "block";
        grandChildMenu.style.visibility = "hidden";

        const grandChildMenuRect = grandChildMenu.getBoundingClientRect();

        // Restore original display
        grandChildMenu.style.display = originalDisplay;
        grandChildMenu.style.visibility = "";

        if (isRTL) {
          if (grandChildMenuRect.left < 0) isOffScreen = true;
        } else {
          if (grandChildMenuRect.right > windowWidth) isOffScreen = true;
        }
      });
    }

    if (isOffScreen) {
      childMenu.setAttribute("data-offscreen", "true");
    } else {
      childMenu.removeAttribute("data-offscreen");
    }
  });
};

/** @type {AbortController | null} */
let menuPositionAbort = null;

/**
 * Bind resize / DOMContentLoaded listeners for submenu overflow correction.
 * Idempotent; pagehide aborts so bfcache pageshow can re-bind.
 */
function initMenuPositionListeners() {
  if (menuPositionAbort) return;
  if (typeof window === "undefined" || typeof document === "undefined") return;

  menuPositionAbort = new AbortController();
  const { signal } = menuPositionAbort;
  window.addEventListener("resize", fixChildMenuPositions, { passive: true, signal });
  if (document.readyState === "loading") {
    window.addEventListener("DOMContentLoaded", fixChildMenuPositions, { signal });
  } else {
    fixChildMenuPositions();
  }
  window.addEventListener(
    "pagehide",
    () => {
      menuPositionAbort?.abort();
      menuPositionAbort = null;
    },
    { once: true, signal },
  );
}

initMenuPositionListeners();

// bfcache restore: pagehide tears listeners down; re-bind on pageshow
window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    initMenuPositionListeners();
  }
});


function initImageTextSliders() {
  document.querySelectorAll('.js-image-text-toggle').forEach((el) => {
    el.addEventListener('click', () => {
      el.classList.toggle('active');
    });
  });
}

['DOMContentLoaded', 'shopify:section:load'].forEach((event) => {
  document.addEventListener(event, initImageTextSliders);
});

var normalize = (str) => str?.toString().trim().toLowerCase() || '';

/**
 * Run callback when main thread is idle to reduce Total Blocking Time (Lighthouse).
 * Uses requestIdleCallback when available, with setTimeout fallback and timeout cap.
 * @param {() => void} callback - Work to run during idle time
 * @param {{ timeout?: number }} [options] - Optional timeout in ms (default 2000)
 */
function scheduleIdle(callback, options = {}) {
  const timeout = options.timeout ?? 2000;
  if (typeof requestIdleCallback !== 'undefined') {
    const id = requestIdleCallback(callback, { timeout });
    return () => cancelIdleCallback(id);
  }
  const id = setTimeout(callback, 1);
  return () => clearTimeout(id);
}

function isCartMutationLocked() {
  return window.__electricCartMutationInFlight === true;
}

function setCartMutationLock(isLocked) {
  const locked = Boolean(isLocked);
  window.__electricCartMutationInFlight = locked;
  document.documentElement.toggleAttribute('data-cart-mutating', locked);

  const cartInteractionRoots = [
    ...document.querySelectorAll('cart-dynamic'),
    ...document.querySelectorAll('drawer-element#cart-drawer drawer'),
  ];

  cartInteractionRoots.forEach((element) => {
    if (!element) return;
    element.toggleAttribute('data-cart-mutating', locked);
    element.setAttribute('aria-busy', locked ? 'true' : 'false');
  });
}

function scheduleCartCountVerification(expectedItemCount, onMismatch, delay = 1000) {
  if (window.__electricCartCountVerificationTimeout) {
    window.clearTimeout(window.__electricCartCountVerificationTimeout);
  }

  window.__electricCartCountVerificationTimeout = window.setTimeout(async () => {
    try {
      const cartUrl = window.routes?.cart_url || '/cart';
      const response = await fetch(/\.js(\?|$)/.test(cartUrl) ? cartUrl : `${cartUrl}.js`);
      if (!response.ok) return;

      const cart = await response.json();
      if (typeof expectedItemCount === 'number' && cart.item_count !== expectedItemCount) {
        onMismatch?.(cart);
      }
    } catch (_error) {
      // Silent verification fallback
    } finally {
      window.__electricCartCountVerificationTimeout = null;
    }
  }, delay);
}



if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.productParentElement = this.closest(
          `[data-section][data-product]`
        );
        this.dataset.section = this.productParentElement.dataset.section;
        this.dataset.product = this.productParentElement.dataset.product;

        this.form = this.querySelector("form");
        this.form.querySelector('[name="id"]').disabled = false;

        this.informationModal = document.querySelector("information-modal");

        // Find all add to cart buttons: main form buttons and sticky buttons
        const mainButtons = this.productParentElement.querySelectorAll(
          'product-buttons [type="submit"]'
        );
        const stickyButtons = this.productParentElement.querySelectorAll(
          'sticky-atc [type="submit"]'
        );
        this.atcButtons = [...mainButtons, ...stickyButtons];
        this.boundOnSubmitHandler = this.onSubmitHandler.bind(this);
        this.boundPageShowHandler = this.onPageShow.bind(this);
        this.boundRestoreHandler = this.onRestoreNavigation.bind(this);
        this.boundVisibilityChangeHandler = this.onVisibilityChange.bind(this);
      }

      connectedCallback() {
        this.form.addEventListener("submit", this.boundOnSubmitHandler);
        window.addEventListener("pageshow", this.boundPageShowHandler);
        window.addEventListener("popstate", this.boundRestoreHandler);
        document.addEventListener("visibilitychange", this.boundVisibilityChangeHandler);
        this.maybeResetAtcState();
        Shopify?.PaymentButton?.init();
      }

      disconnectedCallback() {
        this.form?.removeEventListener("submit", this.boundOnSubmitHandler);
        window.removeEventListener("pageshow", this.boundPageShowHandler);
        window.removeEventListener("popstate", this.boundRestoreHandler);
        document.removeEventListener("visibilitychange", this.boundVisibilityChangeHandler);
      }

      onPageShow() {
        this.maybeResetAtcState();
      }

      onRestoreNavigation() {
        this.maybeResetAtcState();
      }

      onVisibilityChange() {
        if (document.visibilityState !== "visible") return;
        this.maybeResetAtcState();
      }

      maybeResetAtcState() {
        this.resetAtcButtonStates();
        if (sessionStorage.getItem("cart:justAdded") === "1") {
          sessionStorage.removeItem("cart:justAdded");
        }
      }

      resetAtcButtonStates() {
        const buttons = [
          ...this.productParentElement.querySelectorAll('product-buttons [type="submit"]'),
          ...this.productParentElement.querySelectorAll('sticky-atc [type="submit"]')
        ];

        buttons.forEach((button) => {
          button.removeAttribute("data-state");
          button.removeAttribute("aria-disabled");
        });
      }

      onSubmitHandler(evt) {
        // Desktop (lg+): drawer disabled; show spinner on clicked button then native submit → redirect to cart.
        const bp = typeof getCurrentBreakpoint === 'function' ? getCurrentBreakpoint() : '';
        if (['lg', 'xl', 'wide'].includes(bp)) {
          evt.preventDefault();
          const submitter = evt.submitter || evt.target?.querySelector('[type="submit"]');
          if (submitter) {
            submitter.setAttribute('aria-disabled', 'true');
            submitter.setAttribute('data-state', 'loading');
          }
          sessionStorage.setItem('cart:justAdded', '1');
          const form = this.querySelector('form');
          window.addEventListener('pagehide', () => {
            this.resetAtcButtonStates();
          });

          setTimeout(() => {
            if (form && form.parentNode) form.submit();
          }, 120);
          return;
        }
        evt.preventDefault();
        if (this.productParentElement.dataset.variantSelected === "false") {
          const submitter = evt.submitter || evt.submitterPolyfill;

          this.handleErrorMessage(window.variantStrings.selectVariant);
          return;
        }

        this.handleAtcButtonStates("loading");

        this.handleErrorMessage();

        // Open cart drawer immediately (before fetch) so UX feels instant
        document.dispatchEvent(new CustomEvent('cart:adding', { bubbles: true }));

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        // redeclare form to gather updater inputs
        this.form = this.querySelector("form");

        const formData = new FormData(this.form);

        this.dynamicSectionsNodes = document.querySelectorAll("cart-dynamic");

        let dynamicSections = [];
        if (this.dynamicSectionsNodes) {
          dynamicSections = [...this.dynamicSectionsNodes].map(
            (item) => item.dataset.sectionId
          );
        }

        // unique dynamic sections
        dynamicSections = [...new Set(dynamicSections)];

        formData.append("sections", dynamicSections.join(","));
        // formData.append("quantity", this.querySelector('[name="quantity"]').value)
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              let errorMessage = "";
              // if response description is a string
              if (typeof response.description === "string") {
                errorMessage = response.description;
              } else {
                Object.keys(response.description).forEach((key) => {
                  if (key !== "status" && key !== "sections") {
                    errorMessage += `${response.description[key]}\n`;
                  }
                });
              }

              this.handleErrorMessage(errorMessage);
              this.handleAtcButtonStates("error");
              // this.productParentElement.dataset.variantSelected = false;
              return;
            }

            // update dynamic sections (drawer skips refetch when source is product-form)
            let updatedCount = 0;
            this.dynamicSectionsNodes.forEach((node) => {
              const htmlString = response.sections[node.dataset.sectionId];
              if (!htmlString) return;
              const html = new DOMParser().parseFromString(
                htmlString,
                "text/html"
              );
              const source = html.querySelector(
                `cart-dynamic[data-section-id='${node.dataset.sectionId}']`
              );
              if (!source) return;
              node.innerHTML = source.innerHTML;
              node.classList = source.classList;
              if (typeof window.unveilLazyloadIn === 'function') {
                window.unveilLazyloadIn(node);
              }
              node.modified();
              updatedCount++;
            });

            this.handleAtcButtonStates("success");

            // Fetch cart data to include in event
            fetch(`${routes.cart_url}.js`)
              .then(cartResponse => cartResponse.json())
              .then(cart => {
                document.dispatchEvent(new CustomEvent('cart:added', {
                  bubbles: true,
                  detail: {
                    source: 'product-form',
                    product: response,
                    cart: cart,
                    cartItems: cart.items || []
                  }
                }));
              })
              .catch(() => {
                // Fallback: dispatch without cart data
                document.dispatchEvent(new CustomEvent('cart:added', {
                  bubbles: true,
                  detail: {
                    source: 'product-form',
                    product: response
                  }
                }));
              });
          })
          .catch(() => {})
          .finally(() => {});
      }

      handleAtcButtonStates(state) {
        // Re-query buttons each time to handle DOM updates from variant changes
        const mainButtons = this.productParentElement.querySelectorAll(
          'product-buttons [type="submit"]'
        );
        const stickyButtons = this.productParentElement.querySelectorAll(
          'sticky-atc [type="submit"]'
        );
        const atcButtons = [...mainButtons, ...stickyButtons];
        
        atcButtons.forEach((button) => {
          switch (state) {
            case "loading":
              if (button.getAttribute('data-state') === 'loading') return;
              button.setAttribute("aria-disabled", "true");
              button.setAttribute("data-state", "loading");
              break;

            case "error":
              button.dataset.state = "error";
              button.removeAttribute("aria-disabled");
              navigator.vibrate?.(100);
              setTimeout(() => button.removeAttribute("data-state"), 3000);
              break;

            case "success":
              // Don't show success state, just reset to default
              button.removeAttribute("data-state");
              button.removeAttribute("aria-disabled");
              navigator.vibrate?.(100);
              break;
          }
        });
      }
      handleStickySubmit(submitter) {
        if (submitter.closest("sticky-mobile")) {
          const mobileFormDrawer = this.productParentElement.querySelector(
            `drawer-element[id^="product-form-template"]`
          );
          mobileFormDrawer.openDrawer();
          return;
        }

        if (submitter.closest("sticky-desktop")) {
          const variantSelector = submitter
            .closest("sticky-desktop")
            .querySelector(".variant-selector");
          variantSelector.classList.add(
            "outline-offset-2",
            "outline-2",
            "outline-highlight-red"
          );
          variantSelector.addEventListener("click", () => {
            variantSelector.classList.remove(
              "outline-offset-2",
              "outline-2",
              "outline-highlight-red"
            );
          });
          return;
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrappers =
          this.errorMessageWrappers ||
          this.productParentElement.querySelectorAll("error-message");

        this.errorMessageWrappers.forEach((errorMessageWrapper) => {
          if (errorMessage) {
            const errorMessageOutput =
              errorMessageWrapper.querySelector("span");
            errorMessageOutput.textContent = errorMessage;
            errorMessageWrapper.classList.remove("hidden");
            setTimeout(() => {
              errorMessageWrapper.classList.add("hidden");
            }, 3000);
          } else {
            errorMessageWrapper.classList.add("hidden");
          }
        });
      }
    }
  );
}

// Klaviyo Waitlist Form Handler
if (!customElements.get("klaviyo-waitlist-form")) {
  customElements.define(
    "klaviyo-waitlist-form",
    class KlaviyoWaitlistForm extends HTMLFormElement {
      constructor() {
        super();
        this.variantInput = null;
      }

      connectedCallback() {
        this.addEventListener("submit", this.onSubmit.bind(this));
        // Find the hidden variant ID input from the main product form
        this.variantInput = document.querySelector('product-form input[name="id"]');
      }

      async onSubmit(e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent event from bubbling to parent form
        e.stopImmediatePropagation(); // Ensure no other handlers are called
        
        const submitButton = this.querySelector('button[type="submit"]');
        const emailInput = this.querySelector("#klaviyo-waitlist-email");
        
        if (!emailInput.value || !this.variantInput || !this.variantInput.value) {
          this.fail("Missing email or variant information");
          return;
        }

        // Set button to loading state
        if (submitButton) {
          submitButton.dataset.state = "loading";
          submitButton.setAttribute("aria-disabled", true);
        }

        try {
          const result = await this.backInStockSubscription(
            emailInput.value,
            this.variantInput.value
          );
          
          if (!result.ok) {
            throw new Error("Failed to subscribe");
          }
          
          this.success(submitButton);
        } catch (error) {
          this.fail(error.message, submitButton);
        }
      }

      success(button) {
        if (button) {
          button.dataset.state = "success";
          button.removeAttribute("aria-disabled");
        }
        
        // Show success message
        const errorMessageWrapper = document.querySelector("error-message");
        if (errorMessageWrapper) {
          const errorMessageOutput = errorMessageWrapper.querySelector("span");
          errorMessageOutput.textContent = window.variantStrings?.waitlistSuccess || "You're now on the waitlist!";
          errorMessageWrapper.classList.remove("hidden");
          errorMessageWrapper.classList.add("!bg-success", "!text-white");
          setTimeout(() => {
            errorMessageWrapper.classList.add("hidden");
            errorMessageWrapper.classList.remove("!bg-success", "!text-white");
          }, 3000);
        }
        
        // Reset button state after delay
        setTimeout(() => {
          if (button) {
            button.removeAttribute("data-state");
          }
        }, 3000);
      }

      fail(message, button) {
        if (button) {
          button.dataset.state = "error";
          button.removeAttribute("aria-disabled");
          setTimeout(() => {
            button.removeAttribute("data-state");
          }, 3000);
        }
        
        // Show error message
        const errorMessageWrapper = document.querySelector("error-message");
        if (errorMessageWrapper) {
          const errorMessageOutput = errorMessageWrapper.querySelector("span");
          errorMessageOutput.textContent = `Failed to join waitlist: ${message}`;
          errorMessageWrapper.classList.remove("hidden");
          setTimeout(() => {
            errorMessageWrapper.classList.add("hidden");
          }, 3000);
        }
        
      }

      async backInStockSubscription(email, variantId) {
        const raw = {
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                  },
                },
              },
              channels: ["EMAIL"],
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: `$shopify:::$default:::${variantId}`,
                },
              },
            },
          },
        };

        const options = {
          method: "POST",
          headers: {
            accept: "application/json",
            revision: "2023-10-15",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(raw),
        };

        return fetch(
          "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=NnE5A3",
          options
        ).catch((err) => {
          throw err;
        });
      }
    },
    { extends: "form" }
  );
}
